import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const Funnel = ({ size = 16, ...props }: Props) => (
  <>
    <span className="t-sr-only">Filter</span>
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3875_1620)">
        <path
          d="M9.5 14L6.5 11.75V9.19L2.5 4.69V3.5C2.5 3.10218 2.65804 2.72064 2.93934 2.43934C3.22064 2.15804 3.60218 2 4 2H12C12.3978 2 12.7794 2.15804 13.0607 2.43934C13.342 2.72064 13.5 3.10218 13.5 3.5V4.69L9.5 9.19V14ZM7.5 11.25L8.5 12V8.81L12.5 4.31V3.5C12.5 3.36739 12.4473 3.24021 12.3536 3.14645C12.2598 3.05268 12.1326 3 12 3H4C3.86739 3 3.74021 3.05268 3.64645 3.14645C3.55268 3.24021 3.5 3.36739 3.5 3.5V4.31L7.5 8.81V11.25Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3875_1620">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
